import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { OrgSettings } from "@src/types/orgSettings";

export const DEFAULT_ORG_SETTINGS: Partial<OrgSettings> = {};

export const orgSettingsSlice = createSlice({
  name: "orgSettings",
  initialState: DEFAULT_ORG_SETTINGS,
  reducers: {
    setOrgSettings: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { setOrgSettings } = orgSettingsSlice.actions;

export const useOrgSettingsSlice = () => {
  const settings = useSelector(
    (state: any) => state.orgSettings
  ) as OrgSettings;

  const companyName = settings?.company_name;

  const orgName = settings?.organization?.name;
  const orgID = settings?.organization?.id;

  const headerLogo = require("../../../assets/VDB_LOGO.png");
  const lightVDBLogo = require("../../../assets/VDB_LOGO_WHITE.png");

  const companyLogo =
    settings?.secondary_logo ||
    settings?.main_logo_url ||
    settings?.logo_url ||
    process.env.EXPO_PUBLIC_LOGIN_LOGO;

  const customHomepageUrl = settings?.organization?.custom_homepage_url;
  const initStatus = settings?.init_status;
  const faviconUrl = settings?.organization?.favicon_url;
  const showPoweredByVDB = settings?.show_powered_by_vdb;
  const organization = settings.organization;
  const enableJewelryBuilder =
    settings?.organization?.settings?.enable_jewelry_builder;
  const enableJewelryHybridMode =
    settings?.organization?.settings?.enable_hybrid_jewelry_mode;

  const isVDBOrg =
    settings.organization?.id === 1 || settings.organization?.id === 89;
  const isJbtDisabled = settings?.disable_jbt;
  const shoppingCartOfflinePaymentInstructions =
    settings?.organization?.custom_text
      ?.shopping_cart_offline_payment_instructions;

  const orderCartShippingInstructions =
    settings?.organization?.custom_text?.order_cart_shipping_instructions;

  return {
    settings,
    companyName,
    orgName,
    companyLogo,
    customHomepageUrl,
    initStatus,
    faviconUrl,
    showPoweredByVDB,
    organization,
    headerLogo,
    lightVDBLogo,
    enableJewelryBuilder,
    enableJewelryHybridMode,
    isVDBOrg,
    isJbtDisabled,
    shoppingCartOfflinePaymentInstructions,
    orderCartShippingInstructions,
    orgID,
  };
};

export default orgSettingsSlice.reducer;
